import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../ui/button';
import { formatMoney } from '../../utils/formatMoney';

const MobilePriceSummary = ({ selectedVehicle, tripDetails, onContinue }) => {
  // ALWAYS 2 decimals - NO rounding
  const price = selectedVehicle?.price || 0;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 lg:hidden z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] safe-area-bottom"
      data-testid="mobile-price-summary"
    >
      {/* Trust indicators - compact, readable */}
      <div className="bg-emerald-50 px-4 py-2 flex items-center justify-center gap-4 text-xs border-b border-emerald-100">
        <span className="flex items-center gap-1 text-slate-700">
          <Check className="h-3 w-3 text-emerald-600" /> Free cancellation
        </span>
        <span className="flex items-center gap-1 text-slate-700">
          <Check className="h-3 w-3 text-emerald-600" /> No hidden fees
        </span>
      </div>
      
      <div className="p-4">
        <div className="flex items-center justify-between gap-4">
          {/* Price section - left aligned, more prominent */}
          <div className="flex-shrink-0">
            {selectedVehicle ? (
              <>
                <p className="text-xs text-gray-500 font-medium">Total Price</p>
                <p className="text-2xl font-bold text-slate-900 font-display">
                  {formatMoney(price)}
                </p>
              </>
            ) : (
              <p className="text-sm text-gray-500">Select a vehicle</p>
            )}
          </div>
          
          {/* CTA Button - dominant, right side */}
          <Button
            data-testid="mobile-continue-btn"
            className="bg-orange-500 text-white hover:bg-orange-600 h-14 px-6 text-base font-semibold flex-1 max-w-[220px] shadow-md transition-all"
            onClick={onContinue}
            disabled={!selectedVehicle}
          >
            <Check className="h-5 w-5 mr-2 flex-shrink-0" />
            <span className="truncate">Reserve Now</span>
          </Button>
        </div>
        {/* Microcopy */}
        {selectedVehicle && (
          <p className="text-center text-[10px] text-gray-400 mt-2">
            Free cancellation • You won't be charged yet
          </p>
        )}
      </div>
    </div>
  );
};

export default MobilePriceSummary;
